module.exports = __webpack_public_path__ + "media/images/payments/directdebit-dark-00e4a77f34085941311267a12f69f741.svg";